// @flow
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation ShopWithCeoDeleteMutation($input: ShopWithCeoDeleteInput!) {
    shopWithCeoDelete(input: $input) {
      clientMutationId
      user {
        id
        id
        email
        shoppingWithCeoUser {
          publicId
          userId
          firstName
          lastName
          profile {
            image
            city
            state
            zip
          }
        }
      }
      cart {
        id
        billingAddress {
          guestShoppingWithCEO
        }
      }
    }
  }
`;

function commit({ environment, onCompleted, onError }) {
  return commitMutation(environment, {
    mutation,
    variables: { input: {} },
    onCompleted,
    onError,
  });
}

export default { commit };
